import React from 'react'

const Gld9 = () => {
    return (
        <div className='container'>
        <h1>Sort a stack using recursion</h1>
        <p>Given a stack, sort it using recursion. Use of any loop constructs like while, for..etc is not allowed. We can only use the following ADT functions on Stack S: </p>
        <pre className='containers'>{`is_empty(S)  : Tests whether stack is empty or not.
push(S)         : Adds new element to the stack.
pop(S)         : Removes top element from the stack.
top(S)         : Returns value of the top element. Note that this
           function does not remove element from the stack.
`}</pre>

<p><strong>Example:&nbsp;</strong></p>
<pre className='containers'>Input:  -3  &lt;--- Top <br />
    14  <br />
    18  <br />
    -5  <br />
    30  <br />
<br />
Output: 30  &lt;--- Top <br />
    18  <br />
    14  <br />
    -3  <br />
    -5  <br />
</pre>
<p>This problem is mainly a variant of Reverse stack using recursion.<br/>
The idea of the solution is to hold all values in Function Call Stack until the stack becomes empty. When the stack becomes empty, insert all held items one by one in sorted order. Here sorted order is important.<br/>
<strong>Algorithm</strong>&nbsp;<br/>
We can use below algorithm to sort stack elements:&nbsp;</p>
<pre className='containers'>{`sortStack(stack S)
if stack is not empty:
    temp = pop(S);  
    sortStack(S); 
    sortedInsert(S, temp);
`}</pre>
<p>Below algorithm is to insert element is sorted order:&nbsp;</p>
<pre className='containers'>sortedInsert(Stack S, element) <br />
if stack is empty OR element &gt; top element <br />
    push(S, elem) <br />
else <br />
    temp = pop(S) <br />
    sortedInsert(S, element) <br />
    push(S, temp) <br />
</pre>
<p><strong>Illustration:</strong>&nbsp;</p>
<pre className='containers'>Let given stack be <br />
-3    &lt;-- top of the stack <br />
14 <br />
18 <br />
-5 <br />
30  <br />
</pre>
<p>Let us illustrate sorting of stack using above example:<br/>
First pop all the elements from the stack and store poped element in variable ‘temp’. After poping all the elements function’s stack frame will look like:</p>
<pre className='containers'>temp = -3    --&gt; stack frame #1 <br />
temp = 14    --&gt; stack frame #2 <br />
temp = 18    --&gt; stack frame #3 <br />
temp = -5    --&gt; stack frame #4 <br />
temp = 30       --&gt; stack frame #5 <br />
</pre>
<p>Now stack is empty and ‘insert_in_sorted_order()’ function is called and it inserts 30 (from stack frame #5) at the bottom of the stack. Now stack looks like below:</p>
<pre className='containers'><strong>30</strong>    &lt;-- top of the stack 
</pre>
<p>Now next element i.e. -5 (from stack frame #4) is picked. Since -5 &lt; 30, -5 is inserted at the bottom of stack. Now stack becomes:&nbsp;</p>
<pre className='containers'> 30    &lt;-- top of the stack
-5
</pre>
<p>Next 18 (from stack frame #3) is picked. Since 18 &lt; 30, 18 is inserted below 30. Now stack becomes:</p>
<pre className='containers'>30    &lt;-- top of the stack
<strong>18</strong>    
-5
</pre>
<p>Next 14 (from stack frame #2) is picked. Since 14 &lt; 30 and 14 &lt; 18, it is inserted below 18. Now stack becomes:&nbsp;</p>
<pre className='containers'>30    &lt;-- top of the stack
18
<strong>14</strong>    
-5
</pre>
<p>Now -3 (from stack frame #1) is picked, as -3 &lt; 30 and -3 &lt; 18 and -3 &lt; 14, it is inserted below 14. Now stack becomes:</p>
<pre className='containers'>30    &lt;-- top of the stack
18
14
<strong>-3</strong>    
-5
</pre>
<p><strong>Implementation:&nbsp;</strong></p>

        <div class="tabs">
<input type="radio" name="tab" id="tab1" />
<label for="tab1">CPP</label>
<input type="radio" name="tab" id="tab2"/>
<label for="tab2">Java </label>
<input type="radio" name="tab" id="tab3"/>
<label for="tab3">Python</label>
<input type="radio" name="tab" id="tab4"/>
<label for="tab4">C</label>


<div class="tab-content-wrapper">
  <div id="tab-content-1" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// C++ program to sort a stack using recursion</code>
</div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
<div class="line number3 index2 alt2"><code class="keyword bold">using</code> <code
        class="keyword bold">namespace</code> <code class="plain">std;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="comments">// Stack is represented using linked list</code></div>
<div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">stack &#123;</code>
</div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* next;</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#125;;</code></div>
<div class="line number10 index9 alt1">&nbsp;</div>
<div class="line number11 index10 alt2"><code class="comments">// Utility function to initialize stack</code></div>
<div class="line number12 index11 alt1"><code class="keyword bold">void</code> <code
        class="plain">initStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s) &#123; *s = NULL; &#125;</code></div>
<div class="line number13 index12 alt2">&nbsp;</div>
<div class="line number14 index13 alt1"><code class="comments">// Utility function to chcek if stack is empty</code>
</div>
<div class="line number15 index14 alt2"><code class="color1 bold">int</code> <code
        class="plain">isEmpty(</code><code class="keyword bold">struct</code> <code class="plain">stack* s)</code>
</div>
<div class="line number16 index15 alt1"><code class="plain">&#123;</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(s == NULL)</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">1;</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="comments">// Utility function to push an item to stack</code>
</div>
<div class="line number23 index22 alt2"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">stack** s, </code><code
        class="color1 bold">int</code> <code class="plain">x)</code></div>
<div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* p = (</code><code
        class="keyword bold">struct</code> <code class="plain">stack*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code><code
        class="keyword bold">sizeof</code><code class="plain">(*p));</code></div>
<div class="line number26 index25 alt1">&nbsp;</div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(p == NULL) &#123;</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">fprintf</code><code class="plain">(stderr, </code><code
        class="string">"Memory allocation failed.\n"</code><code class="plain">);</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number31 index30 alt2">&nbsp;</div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">p-&gt;data = x;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">p-&gt;next = *s;</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">*s = p;</code></div>
<div class="line number35 index34 alt2"><code class="plain">&#125;</code></div>
<div class="line number36 index35 alt1">&nbsp;</div>
<div class="line number37 index36 alt2"><code
        class="comments">// Utility function to remove an item from stack</code></div>
<div class="line number38 index37 alt1"><code class="color1 bold">int</code> <code class="plain">pop(</code><code
        class="keyword bold">struct</code> <code class="plain">stack** s)</code></div>
<div class="line number39 index38 alt2"><code class="plain">&#123;</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x;</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* temp;</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x = (*s)-&gt;data;</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = *s;</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*s) = (*s)-&gt;next;</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">free</code><code class="plain">(temp);</code></div>
<div class="line number47 index46 alt2">&nbsp;</div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">x;</code></div>
<div class="line number49 index48 alt2"><code class="plain">&#125;</code></div>
<div class="line number50 index49 alt1">&nbsp;</div>
<div class="line number51 index50 alt2"><code class="comments">// Function to find top item</code></div>
<div class="line number52 index51 alt1"><code class="color1 bold">int</code> <code class="plain">top(</code><code
        class="keyword bold">struct</code> <code class="plain">stack* s) &#123; </code><code
        class="keyword bold">return</code> <code class="plain">(s-&gt;data); &#125;</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code
        class="comments">// Recursive function to insert an item x in sorted way</code></div>
<div class="line number55 index54 alt2"><code class="keyword bold">void</code> <code
        class="plain">sortedInsert(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s, </code><code class="color1 bold">int</code> <code class="plain">x)</code></div>
<div class="line number56 index55 alt1"><code class="plain">&#123;</code></div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Base case: Either stack is empty or newly inserted</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// item is greater than top (more than all existing)</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(isEmpty(*s) or x &gt; top(*s)) &#123;</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(s, x);</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number63 index62 alt2">&nbsp;</div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If top is greater, remove the top item and recur</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">temp = pop(s);</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number67 index66 alt2">&nbsp;</div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Put back the top item removed earlier</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(s, temp);</code></div>
<div class="line number70 index69 alt1"><code class="plain">&#125;</code></div>
<div class="line number71 index70 alt2">&nbsp;</div>
<div class="line number72 index71 alt1"><code class="comments">// Function to sort stack</code></div>
<div class="line number73 index72 alt2"><code class="keyword bold">void</code> <code
        class="plain">sortStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s)</code></div>
<div class="line number74 index73 alt1"><code class="plain">&#123;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If stack is not empty</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(!isEmpty(*s)) &#123;</code></div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Remove the top item</code></div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x = pop(s);</code></div>
<div class="line number79 index78 alt2">&nbsp;</div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Sort remaining stack</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s);</code></div>
<div class="line number82 index81 alt1">&nbsp;</div>
<div class="line number83 index82 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Push the top item back in sorted stack</code></div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number86 index85 alt1"><code class="plain">&#125;</code></div>
<div class="line number87 index86 alt2">&nbsp;</div>
<div class="line number88 index87 alt1"><code class="comments">// Utility function to print contents of stack</code>
</div>
<div class="line number89 index88 alt2"><code class="keyword bold">void</code> <code
        class="plain">printStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack* s)</code></div>
<div class="line number90 index89 alt1"><code class="plain">&#123;</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(s) &#123;</code></div>
<div class="line number92 index91 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; s-&gt;data &lt;&lt; </code><code class="string">" "</code><code
        class="plain">;</code></div>
<div class="line number93 index92 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s = s-&gt;next;</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
<div class="line number96 index95 alt1"><code class="plain">&#125;</code></div>
<div class="line number97 index96 alt2">&nbsp;</div>
<div class="line number98 index97 alt1"><code class="comments">// Driver code</code></div>
<div class="line number99 index98 alt2"><code class="color1 bold">int</code> <code class="plain">main(</code><code
        class="keyword bold">void</code><code class="plain">)</code></div>
<div class="line number100 index99 alt1"><code class="plain">&#123;</code></div>
<div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* top;</code></div>
<div class="line number102 index101 alt1">&nbsp;</div>
<div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">initStack(&amp;top);</code></div>
<div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 30);</code></div>
<div class="line number105 index104 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, -5);</code></div>
<div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 18);</code></div>
<div class="line number107 index106 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 14);</code></div>
<div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, -3);</code></div>
<div class="line number109 index108 alt2">&nbsp;</div>
<div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"Stack elements before sorting:\n"</code><code
        class="plain">;</code></div>
<div class="line number111 index110 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(top);</code></div>
<div class="line number112 index111 alt1">&nbsp;</div>
<div class="line number113 index112 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(&amp;top);</code></div>
<div class="line number114 index113 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"\n"</code><code class="plain">;</code></div>
<div class="line number115 index114 alt2">&nbsp;</div>
<div class="line number116 index115 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">cout &lt;&lt; </code><code class="string">"Stack elements after sorting:\n"</code><code
        class="plain">;</code></div>
<div class="line number117 index116 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(top);</code></div>
<div class="line number118 index117 alt1">&nbsp;</div>
<div class="line number119 index118 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number120 index119 alt1"><code class="plain">&#125;</code></div>
<div class="line number121 index120 alt2">&nbsp;</div>
<div class="line number122 index121 alt1"><code
        class="comments">// This code is contributed by SHUBHAMSINGH10</code></div>
</div>
</div>
  <div id="tab-content-2" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// Java program to sort a Stack using recursion</code>
</div>
<div class="line number2 index1 alt1"><code class="comments">// Note that here predefined Stack class is used</code>
</div>
<div class="line number3 index2 alt2"><code class="comments">// for stack operation</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="keyword">import</code> <code
        class="plain">java.util.ListIterator;</code></div>
<div class="line number6 index5 alt1"><code class="keyword">import</code> <code
        class="plain">java.util.Stack;</code></div>
<div class="line number7 index6 alt2">&nbsp;</div>
<div class="line number8 index7 alt1"><code class="keyword">class</code> <code class="plain">Test</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Recursive Method to insert an item x in sorted way</code></div>
<div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">sortedInsert(Stack&lt;Integer&gt; s, </code><code class="keyword">int</code> <code
        class="plain">x)</code></div>
<div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number13 index12 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Base case: Either stack is empty or newly</code></div>
<div class="line number14 index13 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// inserted item is greater than top (more than all</code></div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// existing)</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(s.isEmpty() || x &gt; s.peek())</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(x);</code></div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code><code class="plain">;</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If top is greater, remove the top item and recur</code></div>
<div class="line number23 index22 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">temp = s.pop();</code></div>
<div class="line number24 index23 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number25 index24 alt2">&nbsp;</div>
<div class="line number26 index25 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Put back the top item removed earlier</code></div>
<div class="line number27 index26 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(temp);</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number29 index28 alt2">&nbsp;</div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Method to sort stack</code></div>
<div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">sortStack(Stack&lt;Integer&gt; s)</code></div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If stack is not empty</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="plain">(!s.isEmpty())</code></div>
<div class="line number35 index34 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#123;</code>
</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Remove the top item</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">int</code> <code class="plain">x = s.pop();</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Sort remaining stack</code></div>
<div class="line number40 index39 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s);</code></div>
<div class="line number41 index40 alt2">&nbsp;</div>
<div class="line number42 index41 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Push the top item back in sorted stack</code></div>
<div class="line number43 index42 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code class="plain">&#125;</code>
</div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Utility Method to print contents of stack</code></div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">printStack(Stack&lt;Integer&gt; s)</code></div>
<div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number50 index49 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">ListIterator&lt;Integer&gt; lt = s.listIterator();</code></div>
<div class="line number51 index50 alt2">&nbsp;</div>
<div class="line number52 index51 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// forwarding</code></div>
<div class="line number53 index52 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(lt.hasNext())</code></div>
<div class="line number54 index53 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">lt.next();</code></div>
<div class="line number55 index54 alt2">&nbsp;</div>
<div class="line number56 index55 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// printing from top to bottom</code></div>
<div class="line number57 index56 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">while</code> <code class="plain">(lt.hasPrevious())</code></div>
<div class="line number58 index57 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.print(lt.previous() + </code><code class="string">" "</code><code
        class="plain">);</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number60 index59 alt1">&nbsp;</div>
<div class="line number61 index60 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Driver code</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">public</code> <code class="keyword">static</code> <code class="keyword">void</code> <code
        class="plain">main(String[] args)</code></div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#123;</code></div>
<div class="line number64 index63 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">Stack&lt;Integer&gt; s = </code><code class="keyword">new</code> <code
        class="plain">Stack&lt;&gt;();</code></div>
<div class="line number65 index64 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(</code><code class="value">30</code><code class="plain">);</code></div>
<div class="line number66 index65 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(-</code><code class="value">5</code><code class="plain">);</code></div>
<div class="line number67 index66 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(</code><code class="value">18</code><code class="plain">);</code></div>
<div class="line number68 index67 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(</code><code class="value">14</code><code class="plain">);</code></div>
<div class="line number69 index68 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.push(-</code><code class="value">3</code><code class="plain">);</code></div>
<div class="line number70 index69 alt1">&nbsp;</div>
<div class="line number71 index70 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code></div>
<div class="line number72 index71 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="string">"Stack elements before sorting: "</code><code class="plain">);</code></div>
<div class="line number73 index72 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(s);</code></div>
<div class="line number74 index73 alt1">&nbsp;</div>
<div class="line number75 index74 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s);</code></div>
<div class="line number76 index75 alt1">&nbsp;</div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">System.out.println(</code></div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="string">" \n\nStack elements after sorting:"</code><code class="plain">);</code></div>
<div class="line number79 index78 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(s);</code></div>
<div class="line number80 index79 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number81 index80 alt2"><code class="plain">&#125;</code></div>
</div>
    </div>
  <div id="tab-content-3" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments"># Python program to sort a stack using recursion</code>
</div>
<div class="line number2 index1 alt1">&nbsp;</div>
<div class="line number3 index2 alt2"><code
        class="comments"># Recursive method to insert element in sorted way</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2">&nbsp;</div>
<div class="line number6 index5 alt1"><code class="keyword">def</code> <code
        class="plain">sortedInsert(s, element):</code></div>
<div class="line number7 index6 alt2">&nbsp;</div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Base case: Either stack is empty or newly inserted</code></div>
<div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># item is greater than top (more than all existing)</code></div>
<div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="functions">len</code><code class="plain">(s) </code><code
        class="keyword">=</code><code class="keyword">=</code> <code class="value">0</code> <code
        class="keyword">or</code> <code class="plain">element &gt; s[</code><code class="keyword">-</code><code
        class="value">1</code><code class="plain">]:</code></div>
<div class="line number11 index10 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(element)</code></div>
<div class="line number12 index11 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">return</code></div>
<div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">else</code><code class="plain">:</code></div>
<div class="line number14 index13 alt1">&nbsp;</div>
<div class="line number15 index14 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Remove the top item and recur</code></div>
<div class="line number16 index15 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="plain">s.pop()</code></div>
<div class="line number17 index16 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, element)</code></div>
<div class="line number18 index17 alt1">&nbsp;</div>
<div class="line number19 index18 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Put back the top item removed earlier</code></div>
<div class="line number20 index19 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(temp)</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="comments"># Method to sort stack</code></div>
<div class="line number23 index22 alt2">&nbsp;</div>
<div class="line number24 index23 alt1">&nbsp;</div>
<div class="line number25 index24 alt2"><code class="keyword">def</code> <code class="plain">sortStack(s):</code>
</div>
<div class="line number26 index25 alt1">&nbsp;</div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># If stack is not empty</code></div>
<div class="line number28 index27 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">if</code> <code class="functions">len</code><code class="plain">(s) !</code><code
        class="keyword">=</code> <code class="value">0</code><code class="plain">:</code></div>
<div class="line number29 index28 alt2">&nbsp;</div>
<div class="line number30 index29 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Remove the top item</code></div>
<div class="line number31 index30 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp </code><code class="keyword">=</code> <code class="plain">s.pop()</code></div>
<div class="line number32 index31 alt1">&nbsp;</div>
<div class="line number33 index32 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Sort remaining stack</code></div>
<div class="line number34 index33 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s)</code></div>
<div class="line number35 index34 alt2">&nbsp;</div>
<div class="line number36 index35 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments"># Push the top item back in sorted stack</code></div>
<div class="line number37 index36 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, temp)</code></div>
<div class="line number38 index37 alt1">&nbsp;</div>
<div class="line number39 index38 alt2"><code class="comments"># Printing contents of stack</code></div>
<div class="line number40 index39 alt1">&nbsp;</div>
<div class="line number41 index40 alt2">&nbsp;</div>
<div class="line number42 index41 alt1"><code class="keyword">def</code> <code class="plain">printStack(s):</code>
</div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">for</code> <code class="plain">i </code><code class="keyword">in</code> <code
        class="plain">s[::</code><code class="keyword">-</code><code class="value">1</code><code
        class="plain">]:</code></div>
<div class="line number44 index43 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">(i, end</code><code class="keyword">=</code><code
        class="string">" "</code><code class="plain">)</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword">print</code><code class="plain">()</code></div>
<div class="line number46 index45 alt1">&nbsp;</div>
<div class="line number47 index46 alt2">&nbsp;</div>
<div class="line number48 index47 alt1"><code class="comments"># Driver Code</code></div>
<div class="line number49 index48 alt2"><code class="keyword">if</code> <code class="plain">__name__ </code><code
        class="keyword">=</code><code class="keyword">=</code> <code class="string">'__main__'</code><code
        class="plain">:</code></div>
<div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s </code><code class="keyword">=</code> <code class="plain">[]</code></div>
<div class="line number51 index50 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(</code><code class="value">30</code><code class="plain">)</code></div>
<div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(</code><code class="keyword">-</code><code class="value">5</code><code
        class="plain">)</code></div>
<div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(</code><code class="value">18</code><code class="plain">)</code></div>
<div class="line number54 index53 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(</code><code class="value">14</code><code class="plain">)</code></div>
<div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s.append(</code><code class="keyword">-</code><code class="value">3</code><code
        class="plain">)</code></div>
<div class="line number56 index55 alt1">&nbsp;</div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">print</code><code class="plain">(</code><code
        class="string">"Stack elements before sorting: "</code><code class="plain">)</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(s)</code></div>
<div class="line number59 index58 alt2">&nbsp;</div>
<div class="line number60 index59 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s)</code></div>
<div class="line number61 index60 alt2">&nbsp;</div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions">print</code><code class="plain">(</code><code
        class="string">"\nStack elements after sorting: "</code><code class="plain">)</code></div>
<div class="line number63 index62 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(s)</code></div>
<div class="line number64 index63 alt1">&nbsp;</div>
<div class="line number65 index64 alt2"><code class="comments"># This code is contributed by Muskan Kalra.</code>
</div>
</div>
 </div>
  <div id="tab-content-4" class="tab-content">
  <div class="container">
<div class="line number1 index0 alt2"><code class="comments">// C program to sort a stack using recursion</code>
</div>
<div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;stdio.h&gt;</code></div>
<div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stdlib.h&gt;</code></div>
<div class="line number4 index3 alt1">&nbsp;</div>
<div class="line number5 index4 alt2"><code class="comments">// Stack is represented using linked list</code></div>
<div class="line number6 index5 alt1"><code class="keyword bold">struct</code> <code class="plain">stack &#123;</code>
</div>
<div class="line number7 index6 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">data;</code></div>
<div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* next;</code></div>
<div class="line number9 index8 alt2"><code class="plain">&#125;;</code></div>
<div class="line number10 index9 alt1">&nbsp;</div>
<div class="line number11 index10 alt2"><code class="comments">// Utility function to initialize stack</code></div>
<div class="line number12 index11 alt1"><code class="keyword bold">void</code> <code
        class="plain">initStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s) &#123; *s = NULL; &#125;</code></div>
<div class="line number13 index12 alt2">&nbsp;</div>
<div class="line number14 index13 alt1"><code class="comments">// Utility function to chcek if stack is empty</code>
</div>
<div class="line number15 index14 alt2"><code class="color1 bold">int</code> <code
        class="plain">isEmpty(</code><code class="keyword bold">struct</code> <code class="plain">stack* s)</code>
</div>
<div class="line number16 index15 alt1"><code class="plain">&#123;</code></div>
<div class="line number17 index16 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(s == NULL)</code></div>
<div class="line number18 index17 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">1;</code></div>
<div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number20 index19 alt1"><code class="plain">&#125;</code></div>
<div class="line number21 index20 alt2">&nbsp;</div>
<div class="line number22 index21 alt1"><code class="comments">// Utility function to push an item to stack</code>
</div>
<div class="line number23 index22 alt2"><code class="keyword bold">void</code> <code class="plain">push(</code><code
        class="keyword bold">struct</code> <code class="plain">stack** s, </code><code
        class="color1 bold">int</code> <code class="plain">x)</code></div>
<div class="line number24 index23 alt1"><code class="plain">&#123;</code></div>
<div class="line number25 index24 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* p = (</code><code
        class="keyword bold">struct</code> <code class="plain">stack*)</code><code
        class="functions bold">malloc</code><code class="plain">(</code><code
        class="keyword bold">sizeof</code><code class="plain">(*p));</code></div>
<div class="line number26 index25 alt1">&nbsp;</div>
<div class="line number27 index26 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(p == NULL) &#123;</code></div>
<div class="line number28 index27 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">fprintf</code><code class="plain">(stderr, </code><code
        class="string">"Memory allocation failed.\n"</code><code class="plain">);</code></div>
<div class="line number29 index28 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number31 index30 alt2">&nbsp;</div>
<div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">p-&gt;data = x;</code></div>
<div class="line number33 index32 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">p-&gt;next = *s;</code></div>
<div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">*s = p;</code></div>
<div class="line number35 index34 alt2"><code class="plain">&#125;</code></div>
<div class="line number36 index35 alt1">&nbsp;</div>
<div class="line number37 index36 alt2"><code
        class="comments">// Utility function to remove an item from stack</code></div>
<div class="line number38 index37 alt1"><code class="color1 bold">int</code> <code class="plain">pop(</code><code
        class="keyword bold">struct</code> <code class="plain">stack** s)</code></div>
<div class="line number39 index38 alt2"><code class="plain">&#123;</code></div>
<div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x;</code></div>
<div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* temp;</code></div>
<div class="line number42 index41 alt1">&nbsp;</div>
<div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">x = (*s)-&gt;data;</code></div>
<div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">temp = *s;</code></div>
<div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">(*s) = (*s)-&gt;next;</code></div>
<div class="line number46 index45 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">free</code><code class="plain">(temp);</code></div>
<div class="line number47 index46 alt2">&nbsp;</div>
<div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">x;</code></div>
<div class="line number49 index48 alt2"><code class="plain">&#125;</code></div>
<div class="line number50 index49 alt1">&nbsp;</div>
<div class="line number51 index50 alt2"><code class="comments">// Function to find top item</code></div>
<div class="line number52 index51 alt1"><code class="color1 bold">int</code> <code class="plain">top(</code><code
        class="keyword bold">struct</code> <code class="plain">stack* s) &#123; </code><code
        class="keyword bold">return</code> <code class="plain">(s-&gt;data); &#125;</code></div>
<div class="line number53 index52 alt2">&nbsp;</div>
<div class="line number54 index53 alt1"><code
        class="comments">// Recursive function to insert an item x in sorted way</code></div>
<div class="line number55 index54 alt2"><code class="keyword bold">void</code> <code
        class="plain">sortedInsert(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s, </code><code class="color1 bold">int</code> <code class="plain">x)</code></div>
<div class="line number56 index55 alt1"><code class="plain">&#123;</code></div>
<div class="line number57 index56 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Base case: Either stack is empty or newly inserted</code></div>
<div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// item is greater than top (more than all existing)</code></div>
<div class="line number59 index58 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(isEmpty(*s) || x &gt; top(*s)) &#123;</code></div>
<div class="line number60 index59 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(s, x);</code></div>
<div class="line number61 index60 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code><code class="plain">;</code></div>
<div class="line number62 index61 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number63 index62 alt2">&nbsp;</div>
<div class="line number64 index63 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If top is greater, remove the top item and recur</code></div>
<div class="line number65 index64 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">temp = pop(s);</code></div>
<div class="line number66 index65 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number67 index66 alt2">&nbsp;</div>
<div class="line number68 index67 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Put back the top item removed earlier</code></div>
<div class="line number69 index68 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(s, temp);</code></div>
<div class="line number70 index69 alt1"><code class="plain">&#125;</code></div>
<div class="line number71 index70 alt2">&nbsp;</div>
<div class="line number72 index71 alt1"><code class="comments">// Function to sort stack</code></div>
<div class="line number73 index72 alt2"><code class="keyword bold">void</code> <code
        class="plain">sortStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack** s)</code></div>
<div class="line number74 index73 alt1"><code class="plain">&#123;</code></div>
<div class="line number75 index74 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// If stack is not empty</code></div>
<div class="line number76 index75 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">if</code> <code class="plain">(!isEmpty(*s)) &#123;</code></div>
<div class="line number77 index76 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Remove the top item</code></div>
<div class="line number78 index77 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="color1 bold">int</code> <code class="plain">x = pop(s);</code></div>
<div class="line number79 index78 alt2">&nbsp;</div>
<div class="line number80 index79 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Sort remaining stack</code></div>
<div class="line number81 index80 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(s);</code></div>
<div class="line number82 index81 alt1">&nbsp;</div>
<div class="line number83 index82 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="comments">// Push the top item back in sorted stack</code></div>
<div class="line number84 index83 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortedInsert(s, x);</code></div>
<div class="line number85 index84 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number86 index85 alt1"><code class="plain">&#125;</code></div>
<div class="line number87 index86 alt2">&nbsp;</div>
<div class="line number88 index87 alt1"><code class="comments">// Utility function to print contents of stack</code>
</div>
<div class="line number89 index88 alt2"><code class="keyword bold">void</code> <code
        class="plain">printStack(</code><code class="keyword bold">struct</code> <code
        class="plain">stack* s)</code></div>
<div class="line number90 index89 alt1"><code class="plain">&#123;</code></div>
<div class="line number91 index90 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">while</code> <code class="plain">(s) &#123;</code></div>
<div class="line number92 index91 alt1"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"%d "</code><code
        class="plain">, s-&gt;data);</code></div>
<div class="line number93 index92 alt2"><code
        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">s = s-&gt;next;</code></div>
<div class="line number94 index93 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">&#125;</code></div>
<div class="line number95 index94 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"\n"</code><code
        class="plain">);</code></div>
<div class="line number96 index95 alt1"><code class="plain">&#125;</code></div>
<div class="line number97 index96 alt2">&nbsp;</div>
<div class="line number98 index97 alt1"><code class="comments">// Driver code</code></div>
<div class="line number99 index98 alt2"><code class="color1 bold">int</code> <code class="plain">main(</code><code
        class="keyword bold">void</code><code class="plain">)</code></div>
<div class="line number100 index99 alt1"><code class="plain">&#123;</code></div>
<div class="line number101 index100 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">struct</code> <code class="plain">stack* top;</code></div>
<div class="line number102 index101 alt1">&nbsp;</div>
<div class="line number103 index102 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">initStack(&amp;top);</code></div>
<div class="line number104 index103 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 30);</code></div>
<div class="line number105 index104 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, -5);</code></div>
<div class="line number106 index105 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 18);</code></div>
<div class="line number107 index106 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, 14);</code></div>
<div class="line number108 index107 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">push(&amp;top, -3);</code></div>
<div class="line number109 index108 alt2">&nbsp;</div>
<div class="line number110 index109 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Stack elements before sorting:\n"</code><code class="plain">);</code></div>
<div class="line number111 index110 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(top);</code></div>
<div class="line number112 index111 alt1">&nbsp;</div>
<div class="line number113 index112 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">sortStack(&amp;top);</code></div>
<div class="line number114 index113 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code class="string">"\n\n"</code><code
        class="plain">);</code></div>
<div class="line number115 index114 alt2">&nbsp;</div>
<div class="line number116 index115 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="functions bold">printf</code><code class="plain">(</code><code
        class="string">"Stack elements after sorting:\n"</code><code class="plain">);</code></div>
<div class="line number117 index116 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="plain">printStack(top);</code></div>
<div class="line number118 index117 alt1">&nbsp;</div>
<div class="line number119 index118 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
        class="keyword bold">return</code> <code class="plain">0;</code></div>
<div class="line number120 index119 alt1"><code class="plain">&#125;</code></div>
</div>
 </div>
 </div>
</div>
<br /> <br /> <br /> <br /> <br />
    </div>
    )
}

export default Gld9
